import { render } from "./voting-complete-card.vue?vue&type=template&id=227259c5"
import script from "./voting-complete-card.vue?vue&type=script&lang=js"
export * from "./voting-complete-card.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__